import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import styles from './features_list_accordion.css';
import { toggleAccordion } from '../../../../actions';

export const FeatureListAccordion = ({ id, children }) => {
    const isOpen = useSelector((state) => state.getIn(['vertical', 'quote', 'results', 'config', 'accordionState'])) || false;
    const dispatch = useDispatch();

    const title = isOpen ? 'View less' : 'View more';
    const accordionIcon = isOpen ? faCaretUp : faCaretDown;

    return (
        <div>
            <div
                className={styles.header}
                onClick={() => dispatch(toggleAccordion(id, !isOpen))}
                role="button"
                tabIndex={0}
                data-balanceheight="feature_accordion"
            >
                {(
                    <>
                        <p className={styles.title}>{title}</p>
                        &nbsp;
                        <span className={styles.icon}>
                            <FontAwesomeIcon icon={accordionIcon} size={'sm'} color={'#ffffff'}  />
                        </span>
                    </>
                )}
            </div>
            {isOpen && (
                [...children]
            )}
        </div>
    );
};

FeatureListAccordion.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node.isRequired
};
